
import { Options, Vue } from 'vue-class-component';
import { fgcService, FGCDonation } from '@/services/fgc.service';
import { Subscription } from 'rxjs';

declare const paypal: any;

const GAME_NAMES: Record<string, string> = {
  tekken8: 'Tekken 8',
};

@Options({})
export default class FGCPrizePoolView extends Vue {
  currentTotal = 250;

  get gameTitle(): string {
    const slug = this.$route.params.game as string;
    return GAME_NAMES[slug] ?? 'BGG FGC';
  }
  donations: FGCDonation[] = [];
  donationAmount = '10';
  donorName = '';
  donationNote = '';

  private eventSub: Subscription | null = null;
  private donationsSub: Subscription | null = null;

  get donationsTotal(): number {
    return this.donations.reduce((sum, d) => sum + parseFloat(d.amount as any), 0);
  }

  async mounted() {
    this.eventSub = fgcService.getEvent().subscribe(event => {
      if (event) this.currentTotal = parseFloat(event.current_total as any);
    });
    this.donationsSub = fgcService.getDonations().subscribe(donations => {
      this.donations = donations;
    });
    await Promise.all([fgcService.fetchEvent(), fgcService.fetchDonations()]);
    this.loadPayPalButton();
  }

  unmounted() {
    this.eventSub?.unsubscribe();
    this.donationsSub?.unsubscribe();
  }

  loadPayPalButton() {
    const timeoutId = setTimeout(() => {
      const container = document.getElementById('paypal-button-container');
      if (container && container.querySelector('.loading-placeholder')) {
        container.innerHTML = `
          <div style="padding: 20px; text-align: center;">
            <p style="color: #ff5252; margin-bottom: 10px;">Failed to load PayPal</p>
            <button onclick="location.reload()" style="margin-top: 15px; padding: 8px 16px; cursor: pointer;">Retry</button>
          </div>`;
      }
    }, 10000);

    if (typeof paypal === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://www.paypal.com/sdk/js?client-id=AUpZzwOG2nmCAs8HNfToMQwTBA4c6ziVnX81R5LPbhaznIDZhFLbdjd0_vf52QhcDGX2rNwI3UD2YZom&currency=USD';
      script.onload = () => { clearTimeout(timeoutId); this.renderPayPalButton(); };
      script.onerror = () => {
        clearTimeout(timeoutId);
        const c = document.getElementById('paypal-button-container');
        if (c) c.innerHTML = '<div style="padding:20px;text-align:center;color:#ff5252;">Failed to load PayPal SDK</div>';
      };
      document.head.appendChild(script);
    } else {
      clearTimeout(timeoutId);
      this.renderPayPalButton();
    }
  }

  renderPayPalButton() {
    const container = document.getElementById('paypal-button-container');
    if (!container) return;
    container.innerHTML = '';
    try {
      paypal.Buttons({
        createOrder: (data: any, actions: any) => {
          const amount = parseFloat(this.donationAmount) || 5;
          if (amount < 1) { alert('Minimum donation is $1'); return Promise.reject(); }
          if (amount > 500) { alert('Maximum donation is $500'); return Promise.reject(); }
          return actions.order.create({ purchase_units: [{ amount: { value: amount.toFixed(2) } }] });
        },
        onApprove: async (data: any, actions: any) => {
          const order = await actions.order.capture();
          try {
            const name = this.donorName.trim() || 'Anonymous';
            await fgcService.recordDonation(order.id, name, parseFloat(order.purchase_units[0].amount.value), this.donationNote.trim());
            alert('Thank you for your donation!');
          } catch (e) {
            alert('Donation received but failed to record. Please contact support.');
          }
        },
        onError: (err: any) => { alert('Payment failed. Please try again.'); }
      }).render('#paypal-button-container');
    } catch (error) {
      if (container) container.innerHTML = '<p style="color:red;">Error loading PayPal button.</p>';
    }
  }
}
